// icons
import { Icon } from '@iconify/react';
// @mui
import { Box, type BoxProps } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import React from 'react';

// ----------------------------------------------------------------------


export default function Iconify({ icon, sx, ...other }: {icon: string, sx?: SxProps<Theme>} & BoxProps<typeof Icon>) {
  return <Box component={Icon} icon={icon} sx={{ ...sx }} {...other} />;
}
